import { Routes, RouterModule } from '@angular/router';

import { AdminComponent, ContentComponent } from './';

import { ViewsRoutes } from './views/views.routing';


const routes: Routes = [
    {
        path: 'app',
        component: AdminComponent,
        children: [
            {
                path: '',
                redirectTo: '',
                pathMatch: 'full'
            },
           
            {
                path: 'views',
                component: ContentComponent,
                children: ViewsRoutes
            }
        ]
    }
];

export const AdminRoutes = routes;
